import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Header from '../components/Home/Header'
import Abouthome from '../components/Home/Abouthome'
import Project from '../components/Home/Project'
import Approach from '../components/Home/Approach'
import HomeBanner from '../components/Home/homebanner'
import FAQ from '../components/Home/FAQ'
import Footer from '../components/Footer/Footer'
import Contactfooter from '../components/Contactfooter'
import WhoWeAre from '../components/Home/whoweare'
import CommittedQuality from '../components/Home/CommittedQuality'

const Homepage = () => {
  return (
    <div>
        <Navbar/>
        <Header/>
       <CommittedQuality/>
        <WhoWeAre/>
        <Project/>
        <Approach/>
        <Contactfooter/>
     
        <Footer/>
    </div>
  )
}

export default Homepage